import { Requirement } from "types/requirement";
import { SPECIAL_TAGS, Tag, isAdminOnlyContentTag } from "types/tag";
import { ROLES } from "types/user";

export function requirementHasAdminOnlyContentTag(
  requirement?: Pick<Requirement, "tags"> | null,
): boolean {
  const tags =
    requirement?.tags?.map((entry) => entry.tag).filter(Boolean) || [];
  return tags.some((tag) => isAdminOnlyContentTag(tag as Tag));
}

/**
 * Requirements tagged ADMIN_ONLY_CONTENT are only shown to admins.
 * Hasura also enforces this for the sudo role; this is the client-side mirror.
 */
export function filterAdminOnlyRequirements(
  requirements: Requirement[],
  role?: ROLES | string | null,
): Requirement[] {
  if (role === ROLES.ADMIN) {
    return requirements;
  }
  return requirements.filter(
    (requirement) =>
      requirement && !requirementHasAdminOnlyContentTag(requirement),
  );
}

export function filterAdminOnlyTags(
  tags: Tag[],
  role?: ROLES | string | null,
): Tag[] {
  if (role === ROLES.ADMIN) {
    return tags;
  }
  return tags.filter((tag) => !isAdminOnlyContentTag(tag));
}

export const ADMIN_ONLY_CONTENT_TAG_NAME = SPECIAL_TAGS.ADMIN_ONLY_CONTENT;
